import $axios from "../../api/axios";

function checkUConnectUserApi({ params, callback }) {
    $axios
        .post(`/api/u-connect/checkUser`, params)
        .then(res => {
            callback(res);
        })
        .catch(err => {
            console.log(err);
        });
}

function uConnectCreateUserApi({ params, callback }) {
    $axios
        .post(`/api/u-connect/register`, params)
        .then(res => {
            callback(res);
        })
        .catch(err => {
            console.log(err);
        });
}

function uConnectSubscribeCheckoutApi({ params, callback }) {
    $axios
        .post(`/api/stripe/create-u-connect-checkout-session`, params)
        .then(res => {
            callback(res);
        })
        .catch(err => {
            console.log(err);
        });
}
function updateUConnectUserSessionApi({ params, callback }) {
    $axios
        .post(`/api/stripe/update/u-connect/user/session/${params.token}`, params)
        .then(res => {
            callback(res);
        })
        .catch(err => {
            console.log(err);
        });
}
function getUConnectSubscriptionStatusApi({ params, callback }) {
    $axios
        .post(`/api/session-status/${params.session_id}`, params)
        .then(res => {
            callback(res);
        })
        .catch(err => {
            console.log(err);
        });
}
function getUConnectSubscriptionProductsApi({  callback }) {
    $axios
        .get(`/api/u-connect/stnd/packages`)
        .then(res => {
            callback(res);
        })
        .catch(err => {
            console.log(err);
        });
}
function updateUConnectUserPackageDetailsApi({ params, callback }) {
    $axios
        .post(`/api/u-connect/updateUConnectUser/packageDetails/${params.uConnectRegistrationKey}`, params)
        .then(res => {
            callback(res);
        })
        .catch(err => {
            console.log(err);
        });
}
function updateUConnectUserDetailsApi({ params, callback }) {
    $axios
        .post(`/api/u-connect/updateUConnectUser/${params.uConnectRegistrationKey}`, params)
        .then(res => {
            callback(res);
        })
        .catch(err => {
            console.log(err);
        });
}
function updateUConnectUserTncApi({ params, callback }) {
  $axios
    .post(`/api/u-connect/updateUConnectUser/tnc/${params.uConnectRegistrationKey}`, params)
    .then(res => {
      console.log("response res", res);
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}
function applyCouponCodeApi({ params, callback }) {
  $axios
    .post(`/api/u-connect/applyCouponCode/${params.uConnectRegistrationKey}/${params.couponCode}`, params)
    .then(res => {
      console.log("response res", res);
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}
function releaseCouponCodeApi({ params, callback }) {
  $axios
    .post(`/api/u-connect/releaseCouponCode/${params.uConnectRegistrationKey}`, params)
    .then(res => {
      console.log("response res", res);
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  checkUConnectUserApi,
  uConnectCreateUserApi,
  uConnectSubscribeCheckoutApi,
  updateUConnectUserSessionApi,
  getUConnectSubscriptionStatusApi,
  getUConnectSubscriptionProductsApi,
  updateUConnectUserPackageDetailsApi,
  updateUConnectUserDetailsApi,
  updateUConnectUserTncApi,
  applyCouponCodeApi,
  releaseCouponCodeApi
};



// WEBPACK FOOTER //
// ./src/api/uconnect/uConnect.js